import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function token() {
    const { data } = await supabase.auth.getSession();
    const t = data.session?.access_token;
    if (!t) throw new Error("Session expirée, reconnectez-vous.");
    return t;
}

async function call(path, method = "GET", body) {
    const opts = { method, headers: { Authorization: `Bearer ${await token()}` } };
    if (body !== undefined) {
        opts.headers["Content-Type"] = "application/json";
        opts.body = JSON.stringify(body);
    }
    const r = await fetch(`${BASE}${path}`, opts);
    if (method === "DELETE" && r.ok) return {};
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export const fetchCashRj = (id) => call(`/api/dossiers/${id}/cash-rj`);
export const setSoldeReel = (id, iban, montant) => call(`/api/dossiers/${id}/cash-rj/solde`, "PATCH", { iban, montant });

export const createVirement = (id, body) => call(`/api/dossiers/${id}/cash-rj/virements`, "POST", body || {});
export const updateVirement = (id, vid, body) => call(`/api/dossiers/${id}/cash-rj/virements/${vid}`, "PATCH", body);
export const deleteVirement = (id, vid) => call(`/api/dossiers/${id}/cash-rj/virements/${vid}`, "DELETE");
export const clearVirements = (id) => call(`/api/dossiers/${id}/cash-rj/virements`, "DELETE");

export const createRecurrent = (id, body) => call(`/api/dossiers/${id}/cash-rj/recurrents`, "POST", body || {});
export const updateRecurrent = (id, rid, body) => call(`/api/dossiers/${id}/cash-rj/recurrents/${rid}`, "PATCH", body);
export const deleteRecurrent = (id, rid) => call(`/api/dossiers/${id}/cash-rj/recurrents/${rid}`, "DELETE");

// SUPER-LOT 131 — Virements internes (compte à compte)
export const createVirementInterne = (id, body) => call(`/api/dossiers/${id}/cash-rj/virements-internes`, "POST", body || {});
export const updateVirementInterne = (id, iid, body) => call(`/api/dossiers/${id}/cash-rj/virements-internes/${iid}`, "PATCH", body);
export const deleteVirementInterne = (id, iid) => call(`/api/dossiers/${id}/cash-rj/virements-internes/${iid}`, "DELETE");

export const importChargesFixes = (id, previsionnelId) => call(`/api/dossiers/${id}/cash-rj/recurrents/import-charges-fixes${previsionnelId ? `?previsionnel_id=${encodeURIComponent(previsionnelId)}` : ""}`, "POST", {});
export const fetchCashScenarios = (id) => call(`/api/dossiers/${id}/cash-rj/scenarios`);
export const approuverLot = (id, num_lot) => call(`/api/dossiers/${id}/cash-rj/approuver-lot`, "POST", { num_lot });

export const startAnalyse = (id, documentIds) => call(`/api/dossiers/${id}/cash-rj/analyser/jobs`, "POST", { document_ids: documentIds || null });
export const fetchAnalyseJob = (id, job) => call(`/api/dossiers/${id}/cash-rj/analyser/jobs/${job}`);

// SUPER-LOT 109 — Rapports AJ & fusion de PDF
export const fetchCashDocuments = (id) => call(`/api/dossiers/${id}/cash-rj/documents`);
export const startExportDemande = (id, virement_ids, lot_label) => call(`/api/dossiers/${id}/cash-rj/export/demande-virement/jobs`, "POST", { virement_ids, lot_label });
export const fetchExportDemandeJob = (id, job) => call(`/api/dossiers/${id}/cash-rj/export/demande-virement/jobs/${job}`);
export const startExportReporting = (id, mois, annee) => call(`/api/dossiers/${id}/cash-rj/export/reporting-mensuel/jobs`, "POST", { mois, annee });
export const fetchExportReportingJob = (id, job) => call(`/api/dossiers/${id}/cash-rj/export/reporting-mensuel/jobs/${job}`);
export const fetchRapports = (id) => call(`/api/dossiers/${id}/cash-rj/rapports`);

// SUPER-LOT 114 — Budget vs Actual (BvA) + Note de Gestion IA
export async function uploadBvaFile(id, type, file) {
    const fd = new FormData();
    fd.append("type", type);
    fd.append("file", file);
    const r = await fetch(`${BASE}/api/dossiers/${id}/cash-rj/bva/upload`, { method: "POST", headers: { Authorization: `Bearer ${await token()}` }, body: fd });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}
export const startBvaCompute = (id, body) => call(`/api/dossiers/${id}/cash-rj/bva/compute/jobs`, "POST", body);
export const fetchBvaComputeJob = (id, job) => call(`/api/dossiers/${id}/cash-rj/bva/compute/jobs/${job}`);
export const startBvaNote = (id, report_id) => call(`/api/dossiers/${id}/cash-rj/bva/note/jobs`, "POST", { report_id });
export const fetchBvaNoteJob = (id, job) => call(`/api/dossiers/${id}/cash-rj/bva/note/jobs/${job}`);
export const saveBvaNote = (id, report_id, markdown) => call(`/api/dossiers/${id}/cash-rj/bva/${report_id}/note`, "PATCH", { markdown });
export const fetchBva = (id, mois, annee) => call(`/api/dossiers/${id}/cash-rj/bva?mois=${mois}&annee=${annee}`);
